import React from 'react';
import { useLogin } from '../hooks/useLogin';

const LoginFormTitle = () => {
	const { optionsTitle } = useLogin();

	return (
		<h3 className="vtex-login-2-x-formTitle formTitle t-body v-mid ttu tc relative pv2 ph3 br2">{optionsTitle}</h3>
	);
};

export default LoginFormTitle;
